import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 30px;
`;

const Title = styled.b`
  margin-top: 15px;
  font-size: 18px;
  line-height: 19.2px;
  color: #333333;
  padding-bottom: 10px;
  text-transform: ${({ theme }) => theme.titleTransform};
`;

const Subtitle = styled.p`
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
  text-transform: none;
`;

const Button = styled.button`
  display: flex;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  padding: 10px 16px;
  margin-top: 20px;
  line-height: 20px;
  background: ${({ theme }) => theme.primaryColor};
  color: ${({ theme }) => theme.white};
  font-size: ${({ theme }) => theme.fontSize.sm};
  border: 2px solid ${({ theme }) => theme.primaryColor};
  text-transform: ${({ theme }) => theme.btnTextTransform};
  font-weight: 700;
  width: 100%;

  & :hover {
    color: ${({ theme }) => theme.white};
  }
`;

export { Container, Title, Subtitle, Button };
